
import {SET_BEANID} from '../actions/beanid';
const initialState = {
    beanid: null
};
const beanid = (state = initialState, action) => {
    switch(action.type)
    {
        case SET_BEANID : 
        return { beanid: action.payload.bf_id };
        default:
        return state;
    }
};

export default beanid;


// WEBPACK FOOTER //
// ./src/store/reducers/beanid.js